import AdaptiveImage from "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "antenna.png","uri@2x": __webpack_public_path__ + "antenna.png","uri@3x": __webpack_public_path__ + "antenna.png",
    width: 319,
    height: 232
});